<template>
  <div class="tw-relative">
    <ul class="tw--mb-px tw-flex tw-flex-wrap tw-text-center">
      <slot></slot>
    </ul>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped></style>
